import { transferXYToDistance, translateAngleToXY } from '@/utils/math-kit';
import { type IVectorEffectReflection, type IVectorEffectShadow } from '@/version-types';
import { SHADOW_SIZE } from '../constants';

/**
 * 将阴影的实际坐标距离换算为面板使用的相对距离。
 *
 * @param x - 阴影水平坐标。
 * @param y - 阴影垂直坐标。
 * @param width - 当前图层宽度。
 * @returns 面板使用的整数相对距离。
 */
export const calculateVirtualDistance = (x: number, y: number, width: number): number => {
    return Math.round((transferXYToDistance(x, y) * 100) / width / SHADOW_SIZE);
};

/**
 * 将面板相对距离换算为当前图层的实际坐标距离。
 *
 * @param distance - 面板中的相对距离。
 * @param width - 当前图层宽度。
 * @returns 当前图层坐标系中的实际距离。
 */
export const calculateRealDistance = (distance: number, width: number): number => {
    return (distance / 100) * width * SHADOW_SIZE;
};

/**
 * 创建与当前图层宽度匹配的默认阴影。
 *
 * @param layerWidth - 当前图层宽度。
 * @returns 默认阴影数据。
 */
export const createDefaultShadow = (layerWidth: number): IVectorEffectShadow => {
    const defaultDistance = 30;
    const defaultAngle = -45;
    const relativeDistance = calculateRealDistance(defaultDistance, layerWidth);
    const { x, y } = translateAngleToXY(defaultAngle, relativeDistance);

    return {
        x,
        y,
        hidden: false,
        blur: 20,
        color: '#27272a',
        opacity: 0.3,
    };
};

/**
 * 创建默认倒影数据。
 *
 * @returns 默认倒影数据。
 */
export const createDefaultReflection = (): IVectorEffectReflection => {
    return {
        blur: 5,
        hidden: false,
        y: 0,
        opacity: 0.7,
        size: 100,
    };
};
